<script>
	import { mapActions, mapGetters } from 'vuex'
	import { appUrl } from '../../config'
	export default {
		data() {
				return {
					company_logo:'',
					company_logo_exist:2,
					status: '',
					selected_company: '',
					company_id:'',
					permissions:{
						general: 1,
					},
					remaining_days:'',
					quickmenu:'',
					activemenu:'text-complete',
					currentRouteName:'',
					user:{}
		}
	},
	props: ['type', 'routeHeader', 'routePath','modifyData','refreshCampaignComponent','suborg'],
		beforeMount()
		{	 			
			var currentURL = window.location.pathname;
			this.currentURL=currentURL;
			var permissions =  JSON.parse(localStorage.getItem("permissions"));
			if(permissions)
			{
				 this.permissions.general = permissions.general;
			}

			if(this.$route.path == '/'){
              this.$router.push({ name: 'auth.showoptions' });
              return false;
            }
	
			this.$http.get('/setting/company_logo').then((response) =>
			{
			  this.company_logo_exist = 1;
			  this.company_logo = response.data.data.logo;
			  this.company_id = response.data.data.company_id;
			  this.status = response.data.data.status;
			  this.selected_company = response.data.data.selected_company;
			})
			this.remaining_days =JSON.parse(localStorage.getItem('expired_in'));			
			if(!this.currentUser){
				this.$router.push({ name: 'auth.login' });
			}
			this.currentRouteName = this.$router.currentRoute.name;

			this.user = JSON.parse(localStorage.getItem('user'));
		},
		computed: {
			/**
			* See src/app/auth/vuex/getters.js
			*/
			...mapGetters(['currentUser']),
		},
		methods: {
			/**
			* Makes logout() action available withint this component
			* See /src/app/auth/vuex/actions.js
			*/
			...mapActions(['logout']),
			/* eslint-disable no-undef */
			logoutUser() {		

				

				this.logout();
				localStorage.setItem('user',null);



				window.location = appUrl+'/logout';
			},
			updateAdminLogin(){
			var data = {};
			 data.admin_company_id = this.company_id;
			this.$http.post('/adminlogin/updateadminlogin',data).then((response) =>
			{
			   if(response.data)
			   {
				 location.reload();
			   }
			})
			},
			quickview(){
				if(this.quickmenu == 'open'){
					this.quickmenu = '';
				}else{
					this.quickmenu = 'open';
				}
				
			}		
		},
	}
</script>
<template>
 

     <div class="header">
        <a href="#" class="btn-link toggle-sidebar d-lg-none pg-icon btn-icon-link" data-toggle="sidebar">
          menu</a>
        <div class="in_mobile">
          <div class="brand inline d-none d-lg-block d-xl-block" >
            
			 <img v-if="company_logo" :src="company_logo" class="logo_c" alt="logo" :data-src="company_logo"   :data-src-retina="company_logo"  style="height:60px;">
          
          </div>
        </div>
        <div class="d-flex align-items-center">
          <span style="display: none;" class="theme_change  btn-icon-link"><i class="fas fa-sun"></i><i class="far fa-moon"></i></span>
          
          <div class="dropdown pull-right d-lg-block d-none">
            <button class="profile-dropdown-toggle logindetail_p" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="profile dropdown">
               <div class="logindetail">
                  <span>{{user.company}}</span>
                  <span>{{user.first_name}} {{user.last_name}}</span>
               </div>
               <span class="thumbnail-wrapper d32 circular inline">
                <img src="/static/assets/img/user.svg" alt="" data-src="/static/assets/img/user.svg" data-src-retina="/static/assets/img/user.svg" width="32" height="32">
               </span>
            </button>

            <div class="dropdown-menu dropdown-menu-right profile-dropdown" role="menu">               
               <a class="pull-left" style="cursor: pointer;" @click="logoutUser()">Logout</a>
               <div class="dropdown-divider"></div>               
            </div>

         </div>

        </div>
      </div>

</template>


// WEBPACK FOOTER //
// navbar.vue?520bdad4